import { createSlice } from '@reduxjs/toolkit';
import { attachDetachTestimonyProgram } from './Utils/TestimonyProgramUtils';

const initialState = {
    method: '',
    type: 'posttest',
    idSubmateri: '',
    idTryout: '',
    isLoading: false,
};

const attachDetachTestimonyProgramSlice = createSlice(
    {
        name: 'attachDetachTestimonyProgram',
        initialState: initialState,
        reducers: {
            setField: (state, action) => {
                const { field, value } = action.payload;
                state[field] = value;
            },
            resetState: (state) => {
                return initialState;
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(attachDetachTestimonyProgram.pending, (state) => {
                    // Handle loading state
                    state.isLoading = true;
                })
                .addCase(attachDetachTestimonyProgram.fulfilled, (state, action) => {
                    state.isLoading = false;
                })
                .addCase(attachDetachTestimonyProgram.rejected, (state, action) => {
                    state.isLoading = false;
                });
        }
    }
);


export const { setField, resetState } = attachDetachTestimonyProgramSlice.actions;

export default attachDetachTestimonyProgramSlice.reducer;